import HTTP from "@/http";

export function postZhuCe(data = {}) {
  return HTTP({
    url: "api/zhuce",
    method: "POST",
    data,
  });
}

export function postDengLu(data = {}) {
  return HTTP({
    url: "api/denglu",
    method: "POST",
    data,
  });
}

export function putJiHuo(data = {}) {
  return HTTP({
    url: "api/jihuo",
    method: "PUT",
    data,
  });
}

export function putYongHuEmail(data = {}) {
  return HTTP({
    url: "api/yonghu/email",
    method: "PUT",
    data,
  });
}

export function putJiHuoMa(data = {}) {
  return HTTP({
    url: "api/email/jihuoma",
    method: "PUT",
    data,
  });
}

export function putYongHuPassword(data = {}) {
  return HTTP({
    url: "auth/yonghu/password",
    method: "PUT",
    data,
  });
}

export function putYongHu(data = {}) {
  return HTTP({
    url: "auth/yonghu",
    method: "PUT",
    data,
  });
}
